import React from "react";
import { decode } from "html-entities";
import { Link } from "react-router-dom";

export default function ArticleHead({ post }) {
    if (!post) {
        return (
            <article className="article-head">
                <Link to="/blog" className="back-link">← Back to insights</Link>
                <div className="eyebrow placeholder-line small" />
                <h1 className="placeholder-line title" />
                <div className="byline">
                    <span className="avatar">
                        <span className="placeholder-box" style={{width:48, height:48, borderRadius:8}} />
                    </span>
                    <div>
                        <div className="n placeholder-line small" />
                        <div className="m placeholder-line tiny" />
                    </div>
                </div>
            </article>
        );
    }

    // Ensure a consistent Date object from YYYY-MM-DD strings
    const date = post.publish_date ? new Date(`${post.publish_date}T00:00:00`) : null;
    const formattedDate = date ? date.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' }) : '';

    return (
        <article className="article-head">
            <Link to="/blog" className="back-link">← Back to insights</Link>
            {post.category_name && post.category_name.toLowerCase() !== "uncategorized" && (
                <div className="eyebrow">{decode(post.category_name) || ""}</div>
            )}
            <h1>{decode(post.title)}</h1>
            <div className="byline">
                <span className="avatar">
                    <img src={post.post_admin_logo} alt="Kudosta Team" />
                </span>
                <div>
                    <div className="n">Kudosta Team</div>
                    {String(post.is_date_show) === "1" && (
                        <div className="m">{formattedDate}</div>
                    )}
                </div>
            </div>
        </article>
    );
}
